import React, { Component } from 'react'
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom'
import './scss/style.scss'
import VerificationCode from './views/pages/verificationCodePage'

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

// Containers
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'))

// Pages
const Login = React.lazy(() => import('./views/pages/login/Login'))
const Register = React.lazy(() => import('./views/pages/register/Register'))
const Page404 = React.lazy(() => import('./views/pages/page404/Page404'))
const Page500 = React.lazy(() => import('./views/pages/page500/Page500'))
const ForgotPassword = React.lazy(() => import('./views/pages/forgotPassword'))
const ForgotPasswordConfirm = React.lazy(() => import('./views/pages/forgotPasswordConfirm'))

class App extends Component {
  render() {
    return (
      <BrowserRouter>
        <React.Suspense fallback={loading}>
          <Switch>
            <Route exact path="/login" name="Login Page" render={(props) => <Login {...props} />} />
            <Route
              exact
              path="/register"
              name="Register Page"
              render={(props) => <Register {...props} />}
            />
            <Route exact path="/500" name="Page 500" render={(props) => <Page500 {...props} />} />
            <Route exact path="/">
              {localStorage.getItem('authToken') != null ? (
                <Redirect to="/dashboard" />
              ) : (
                <Redirect to="/login" />
              )}
            </Route>
            <Route
              exact
              path="/dashboard"
              name="Home"
              render={(props) => <DefaultLayout {...props} />}
            />
            <Route
              exact
              path="/dashboardrides"
              name="Home"
              render={(props) => <DefaultLayout {...props} />}
            />
            <Route
              exact
              path="/dashboardrivers"
              name="Home"
              render={(props) => <DefaultLayout {...props} />}
            />
            <Route
              exact
              path="/financials"
              name="Financials"
              render={(props) => <DefaultLayout {...props} />}
            />
            <Route
              exact
              path="/drivers"
              name="Drivers"
              render={(props) => <DefaultLayout {...props} />}
            />
            <Route
              exact
              path="/driverslocations"
              name="DriversLocations"
              render={(props) => <DefaultLayout {...props} />}
            />
            <Route
              exact
              path="/driversearning"
              name="DriversEarning"
              render={(props) => <DefaultLayout {...props} />}
            />
            <Route
              exact
              path="/driversearnings"
              name="DriversEarnings"
              render={(props) => <DefaultLayout {...props} />}
            />
            <Route
              exact
              path="/driversincentive"
              name="DriversIncentive"
              render={(props) => <DefaultLayout {...props} />}
            />
            <Route
              exact
              path="/franchisedrivers"
              name="franchisedrivers"
              render={(props) => <DefaultLayout {...props} />}
            />
            <Route
              exact
              path="/rental"
              name="Rental"
              render={(props) => <DefaultLayout {...props} />}
            />
            <Route
              exact
              path="/rentalvehicle"
              name="Rental Vehicle"
              render={(props) => <DefaultLayout {...props} />}
            />
            <Route
              exact
              path="/rentalbrands"
              name="Rental Brands"
              render={(props) => <DefaultLayout {...props} />}
            />
            <Route
              exact
              path="/driverswallet"
              name="Driverswallet"
              render={(props) => <DefaultLayout {...props} />}
            />
            <Route
              exact
              path="/driverswithdrawal"
              name="Driverswithdrawal"
              render={(props) => <DefaultLayout {...props} />}
            />
            <Route
              exact
              path="/driversincentive"
              name="Driversincentive"
              render={(props) => <DefaultLayout {...props} />}
            />
            <Route
              exact
              path="/driversdeposit"
              name="Driversdeposit"
              render={(props) => <DefaultLayout {...props} />}
            />
            <Route
              exact
              path="/subscription"
              name="Subscription"
              render={(props) => <DefaultLayout {...props} />}
            />
            <Route
              exact
              path="/emailreport"
              name="EmailReport"
              render={(props) => <DefaultLayout {...props} />}
            />
            <Route
              exact
              path="/users"
              name="Users"
              render={(props) => <DefaultLayout {...props} />}
            />
            <Route
              exact
              path="/admins"
              name="Admins"
              render={(props) => <DefaultLayout {...props} />}
            />
            <Route
              exact
              path="/profile"
              name="Profile"
              render={(props) => <DefaultLayout {...props} />}
            />
            <Route
              exact
              path="/all-rides"
              name="All Rides"
              render={(props) => <DefaultLayout {...props} />}
            />
            <Route
              exact
              path="/pending-rides"
              name="All Rides"
              render={(props) => <DefaultLayout {...props} />}
            />
            <Route
              exact
              path="/cancelled-rides"
              name="All Rides"
              render={(props) => <DefaultLayout {...props} />}
            />
            <Route
              exact
              path="/completed-rides"
              name="All Rides"
              render={(props) => <DefaultLayout {...props} />}
            />
            <Route
              exact
              path="/vehicle-types"
              name="Vehicle Stats"
              render={(props) => <DefaultLayout {...props} />}
            />
            <Route
              exact
              path="/vehicle-info"
              name="Vehicle Info"
              render={(props) => <DefaultLayout {...props} />}
            />
            <Route
              exact
              path="/forgot-password"
              name="Forgot Password"
              render={(props) => <ForgotPassword {...props} />}
            />
            <Route
              exact
              path="/forgot-password-confirm"
              name="Forgot Password Confirm"
              render={(props) => <ForgotPasswordConfirm {...props} />}
            />
            <Route
              exact
              path="/verify-verification-code"
              name="Verify Verification Code"
              render={(props) => <VerificationCode {...props} />}
            />
            <Route
              exact
              path="/faqs"
              name="FAQS"
              render={(props) => <DefaultLayout {...props} />}
            />
            <Route
              exact
              path="/areas"
              name="Areas"
              render={(props) => <DefaultLayout {...props} />}
            />
            <Route
              exact
              path="/courier"
              name="Courier"
              render={(props) => <DefaultLayout {...props} />}
            />
            <Route
              exact
              path="/areapolygon"
              name="Area Polygon"
              render={(props) => <DefaultLayout {...props} />}
            />
            <Route
              exact
              path="/areapolygon2"
              name="Area Polygon2"
              render={(props) => <DefaultLayout {...props} />}
            />
            <Route exact path="/404" name="Page 404" render={(props) => <Page404 {...props} />} />
            <Route path="*" name="Page 404" render={(props) => <Page404 {...props} />} />
          </Switch>
        </React.Suspense>
      </BrowserRouter>
    )
  }
}

export default App
